import React from 'react';
import { Menu, X } from 'lucide-react';

const CandidateMobileHeader = ({ mobileMenuOpen, setMobileMenuOpen }) => {
  return (
    <div className="sticky top-0 z-30 bg-white border-b border-gray-200 p-4">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <span className="text-xl font-bold text-black">Job<span className="text-yellow-400">Loop</span></span>
        </div>
        <button 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="p-2 rounded-md text-black hover:bg-gray-100"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </div>
  );
};

export default CandidateMobileHeader;
